const styles = {
  button: {
    '&&': {
      marginRight: '1em',
    },
  },
};

export default styles;
